/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, NgZone} from '@angular/core';
import template from './custom-event-edit-page.component.html';
import {AppEventBusService} from '../../common/events/app-event-bus.service';

import {LocalNetworkInfo} from '../../../components/session/local-network-info';
import {AdminResourceEditPageBase} from '../../common/controller/admin-resource-edit-page-base';
import {CUSTOM_EVENT_CONVERSION_TYPES, CustomEventConversionType} from './custom-event-commons';
import * as _ from 'lodash';
import {LocalNetworkProfile} from '../../../components/session/local-network-profile';
import {UserProfileSaverService} from '../../../components/session/user-profile-saver.service';

@Component({
  standalone: false,
  selector: 'adn-custom-event-edit-page',
  template
})
export class CustomEventEditPageComponent extends AdminResourceEditPageBase {
  conversionTypes: CustomEventConversionType[] = CUSTOM_EVENT_CONVERSION_TYPES;

  constructor(
    eventBus: AppEventBusService,
    @Inject(UserProfileSaverService) UserProfileSaver: any,
    @Inject(LocalNetworkProfile) LocalNetworkProfile: any,
    ngZone: NgZone
  ) {
    super(eventBus, UserProfileSaver, LocalNetworkProfile, ngZone);
  }

  protected onBeforeSubmit(): void {
    LocalNetworkInfo.obtain().addCustomEvent(this.editingModel);
  }

  protected afterInitEditingModel(): void {
    if (this.editingModel.conversionType === undefined) {
      this.editingModel.conversionType = null;
    }
  }

  protected afterInitAfterSave(saveObj?: any): void {
    this.editingModel.type = _.get(saveObj || this.editingModel, ['type']) || 'COUNT';
  }
}
